// extracted by mini-css-extract-plugin
module.exports = {"customNvabarItem":"customNvabarItem_mbd0B"};